import { IS_ADMIN, IS_ANONYMOUS } from "../../constants/Constants.js";

const AdminUser = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "fa fa-th-large",
  },
  {
    name: "Users",
    url: "/adminUser",
    icon: "fa fa-user-circle-o",
  },
  {
    name: "Groups",
    url: "/groups",
    icon: "fa fa-group",
  },
  {
    name: "Compute",
    icon: "fa fa-server",
    children: [
      {
        name: "Docker Agents",
        url: "/agents",
        icon: "fa fa-cubes",
      },
      {
        name: "Servers",
        url: "/servers",
        icon: "fa fa-server",
      },
      {
        name: "Pools",
        url: "/server_pools",
        icon: "fa fa-object-group",
      },
    ],
  },
  {
    name: "Managers",
    url: "/managers",
    icon: "fa fa-shield",
  },
  {
    name: "Zones",
    url: "/zones",
    icon: "fa fa-map-o",
  },
  {
    name: "Connection Proxies",
    url: "/connection_proxies",
    icon: "fa fa-plug",
  },
  {
    name: "Staging",
    url: "/staging",
    icon: "fa fa-flask",
  },
  {
    name: "Casting",
    url: "/cast",
    icon: "fa fa-rss fa-rotate-90",
  },
  {
    name: "Sessions",
    url: "/kasm",
    icon: "fa fa-table",
  },
  {
    name: "Workspaces",
    url: "/workspaces",
    icon: "fa fa-window-restore",
  },
  {
    name: "Developers",
    url: "/developers",
    icon: "fa fa-code-fork",
  },
  {
    name: "Web Filter",
    url: "/webfilter",
    icon: "fa fa-ban",
  },
  {
    name: "Branding",
    url: "/branding",
    icon: "fa fa-paint-brush",
  },
  {
    name: "Settings",
    url: "/settings",
    icon: "fa fa-wrench",
  },
  {
    name: "Authentication",
    icon: "fa fa-key",
    children: [
      {
        name: "LDAP",
        url: "/ldap",
        icon: "fa fa-book",
      },
      {
        name: "SAML",
        url: "/saml",
        icon: "fa fa-book",
      },
      {
        name: "OpenID",
        url: "/oidc",
        icon: "fa fa-book",
      },
      {
        name: "Physical Tokens",
        url: "/physical_tokens",
        icon: "fa fa-book"
      }
    ],
  },
  {
    name: "System Info",
    url: "/systeminfo",
    icon: "fa fa-exclamation-circle",
  },
  {
    name: "Logging",
    url: "/logging",
    icon: "icon-pencil",
  },
];

const normalUser = [
  {
    title: true,
    name: "USER",
  },
  {
    name: "Kasm",
    url: "/userdashboard",
    icon: "fa fa-desktop",
  },
  {
    name: "Launch Now",
    url: "/go",
    icon: "fa fa-arrow-circle-right",
  },
  {
    name: "Profile",
    url: "/userprofile",
    icon: "fa fa-user-circle",
  },
  {
    name: "Logout",
    url: "/logout",
    icon: "icon-logout",
  },
];

const anonymousUser = [
  {
    title: true,
    name: "USER",
  },
  {
    name: "Logout",
    url: "/logout",
    icon: "icon-logout",
  },
];

export default () => {
  if (IS_ADMIN) {
    return AdminUser;
  } else if (!IS_ANONYMOUS) {
    return normalUser;
  } else {
    return anonymousUser;
  }
};
